import React, { useContext } from "react";
import { Platform } from "react-native";
import {
  Typography,
  Box,
  Stack,
  OldButton as Button,
  Spacer,
  Divider,
} from "digiwash-components";
import { formatPrice } from "digiwash-core";
import { color } from "@sloth-system/styled-utils";

import { CreditContext } from "../../contexts/credit";
import styled from "styled-components/native";
import CustomIcon from "../../components/CustomIcon";

const webStyles =
  Platform.OS === "web"
    ? {
        container: {
          maxWidth: 768,
          margin: "auto",
          width: "100%",
        },
      }
    : {};

const Container = styled(Box)`
  border: 1px solid ${color("primary.light930")};
`;

const RightColumnContainer = styled(Box)`
  border-left-width: 1px;
  border-left-color: ${color("neutrals.150")};
`;

interface PropTypes {
  data: any;
}

function CreditInfo(props: PropTypes) {
  let { data } = props;
  let { setCreditModalOpen } = useContext(CreditContext);
  let hasData = data?.balance;

  if (typeof hasData === "undefined") {
    return null;
  }

  return (
    <Box>
      <Box p="l" style={webStyles.container}>
        <Container
          px="xxl"
          py="l"
          bg="common.white"
          br="m"
          style={{ flexGrow: 1 }}
        >
          <Stack distribution="space-between" alignment="center">
            <Typography ff="mainMedium" fs="m">
              {formatPrice(Number(data.balance) + Number(data.gift_balance))}{" "}
              تومان اعتبار
            </Typography>
            <Button
              onPress={() => {
                setCreditModalOpen(true, { origin: "profile" });
              }}
            >
              <Typography fs="m" ff="mainBold" color="primary.main">
                افزایش اعتبار
              </Typography>
            </Button>
          </Stack>
          <Divider size="xxl" />
          <Stack distribution="space-between" alignment="center">
            <RightColumnContainer
              alignment="center"
              style={{
                width: "50%",
              }}
            >
              <Stack direction="vertical" distribution="center">
                <Stack>
                  <CustomIcon icon="wallet" width={30} height={30} />
                  <Spacer size="m" />
                  <Typography fs="xm" color="common.black" ff="mainMedium">
                    کیف پول
                  </Typography>
                </Stack>
                <Divider size="m" />
                <Typography color="common.black" fs="xm" ff="mainLight">
                  {formatPrice(data.balance)} تومان
                </Typography>
              </Stack>
            </RightColumnContainer>
            <Box
              style={{
                width: "50%",
              }}
            >
              <Stack direction="vertical" distribution="center">
                <Stack>
                  <CustomIcon icon="gift" width={30} height={30} />
                  <Spacer size="m" />
                  <Typography fs="xm" color="common.black" ff="mainMedium">
                    اعتبار هدیه
                  </Typography>
                </Stack>
                <Divider size="m" />
                <Typography color="common.black" fs="xm" ff="mainLight">
                  {formatPrice(data.gift_balance)} تومان
                </Typography>
              </Stack>
            </Box>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}

export default CreditInfo;
